// extracted by css-extract-rspack-plugin
export default {"grid":"Dashboard__grid--isEvS"};